<template>
    <div class="menu_search__container flex-column md:flex-row w-full xl:w-auto">
        <div class="menu_search__search_container w-full">
            <form
                ref="form"
                :action="getFormAction"
                autocomplete="on"
                method="GET"
                @submit.prevent
                class="w-full"
            >
                <div class="card flex w-full relative menu_search__form">
                    <div class="w-full menu_search__form_search_container">
                        <AdaptersAutoComplete
                            v-model="model.search"
                            :suggestions="suggestion"
                            @change="doFilter"
                            :placeholder="currentPlaceholder()"
                            :minLength="searchLengthLoadData"
                            class="w-full"
                            inputClass="p-input-sm w-full"
                            @keyup.enter="submitForm"
                            @paste="paste"
                            :delay="searchDelayLoadData"
                            ref="searchplace"
                            @item-select="itemSelect"
                            @before-show="beforeShow"
                            @focus="focusSearch = true"
                            @blur="focusSearch = false"
                            @mouseenter="hoverSearch = true"
                            @mouseleave="hoverSearch = false"
                            :pt="{
                                item: ({ props, state, context }) => ({
                                    class: 'font-light'
                                }),
                                panel: { style: 'max-width: 1;' },
                                loadingIcon: {class: 'hidden'},
                                input: {name: fieldName, class: 'menu_search__form_search_input'}
                            }"
                        ></AdaptersAutoComplete>
                    </div>
                    <div
                        class="flex align-items-center absolute menu_search__database_container"
                        :class="{'menu_search__form_database_focus': (focusSearch || hoverSearch)}"
                        ref="databaseContainer"
                    >
                        <i
                            class="pi pi-search menu_search__button"
                            :class="{active: (model.search && model.search.length)}"
                            @click="submitForm"
                        ></i>
                        <div v-show="showDb && currentBase">
                            <AdaptersDropdown
                                v-model="currentBase"
                                :options="bases"
                                optionLabel="caption"
                                @change="onChangeDatabase"
                                filter
                                :disabled="!enableSelect"
                                class="menu_search__form_database"
                                :resetFilterOnHide="true"
                                :hoverUsage="true"
                            >
                                <template #value="slotProps">
                                    <div v-if="slotProps.value" class="flex align-items-center">
                                        <img :alt="slotProps.value.caption" :src="getEngineIcon(slotProps.value.engine)" />
                                        <div>{{ slotProps.value.short }}</div>
                                        <i class="fa fa-caret-down"></i>
                                    </div>
                                    <span v-else>
                                        {{ slotProps.placeholder }}
                                    </span>
                                </template>
                                <template #filtericon>
                                    <i class="pi pi-search" />
                                </template>
                            </AdaptersDropdown>
                        </div>
                    </div>
                </div>
                <input v-if="!isPageYandexDirect" :value="getCurrentDatabaseName" name="db" type="hidden" />
            </form>
        </div>
        <div v-if="useLinks" class="menu_search__links_container w-full md:w-auto">
            <div class="flex gap-2 w-full flex-nowrap">
                <template v-if="isGroup">
                    <a
                        href
                        @click.prevent
                        @mouseenter="onHoverOrganicGroup"
                        :class="{active: isPageOrganicGroup}"
                    >
                        <span>{{ $t('lang.menu.search.organic_group.label') }}</span>
                        <i class="fa fa-caret-down"></i>
                    </a>
                    <a
                        v-if="hasAds"
                        href
                        @click.prevent
                        @mouseenter="onHoverContextGroup"
                        :class="{active: isPageContextGroup}"
                    >
                        <span>{{ $t('lang.menu.search.context_group.label') }}</span>
                        <i class="fa fa-caret-down"></i>
                    </a>
                    <a
                        v-else
                        href
                        @click.prevent
                        v-tooltip.bottom="$t('lang.menu.search.no_data')"
                    >
                        <span>{{ $t('lang.menu.search.context_group.label') }}</span>
                    </a>
                    <MenuSubmenuOrganicGroup :currentPage="currentGroupPage" />
                    <MenuSubmenuContextGroup :currentPage="currentGroupPage" />
                </template>
                <template v-else>
                    <a
                        v-if="isYandexMsk"
                        href
                        @click.prevent
                        @mouseenter="onHoverAiAnswers"
                        :class="{active: isPageAiAnswers}"
                    >
                        <span>{{ $t('lang.menu.search.ai_answers.label') }}</span>
                        <i class="fa fa-caret-down"></i>
                    </a>
                    <a
                        href
                        @click.prevent
                        @mouseenter="onHoverOrganic"
                        :class="{active: isPageOrganic}"
                    >
                        <span>{{ $t('lang.menu.search.organic.label') }}</span>
                        <i class="fa fa-caret-down"></i>
                    </a>
                    <a
                        href
                        @click.prevent
                        @mouseenter="onHoverLinks"
                        :class="{active: isPageLinks}"
                    >
                        <span>{{ $t('lang.menu.search.links.label') }}</span>
                        <i class="fa fa-caret-down"></i>
                    </a>
                    <a
                        v-if="hasAds"
                        href @click.prevent
                        @mouseenter="onHoverContext"
                        :class="{active: isPageContext}"
                    >
                        <span>{{ $t('lang.menu.search.context.label') }}</span>
                        <i class="fa fa-caret-down"></i>
                    </a>
                    <a
                        v-else
                        href
                        @click.prevent
                        v-tooltip.bottom="$t('lang.menu.search.no_data')"
                    >
                        <span>{{ $t('lang.menu.search.context.label') }}</span>
                    </a>
                    <MenuSubmenuOrganic :domain="initialValue" :hasTree="hasTree" />
                    <MenuSubmenuLinks :domain="initialValue" />
                    <MenuSubmenuContext v-if="hasAds" :domain="initialValue" />
                    <MenuSubmenuAiAnswers
                        v-if="isYandexMsk"
                        :domain="initialValue"
                        :dbname="currentBaseName"
                    />
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import Engine from '../../../mixins/Engine'
import {toUnicode as punycodeToUnicode} from 'punycode-url';
import {nextTick} from "vue";
import Button from "primevue/button";
import {ArrayHelper} from "../../../helpers/ArrayHelper";
import {BaseEngineIcons} from "../../../constants/baseEngineIcons";
import AdaptersDropdown from "../../../component/adapters/Dropdown.vue";
import AdaptersAutoComplete from "../../../component/adapters/AutoComplete.vue";
import AdaptersLoader from "../../adapters/Loader.vue";
import {Listeners} from "../../../constants/listeners";
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import DomainApi from "../../../api/DomainApi";
import MenuSubmenuOrganic from "./SubmenuOrganic.vue";
import MenuSubmenuLinks from "./SubmenuLinks.vue";
import MenuSubmenuContext from "./SubmenuContext.vue";
import MenuSubmenuAiAnswers from "./SubmenuAiAnswers.vue";
import {Pages} from "../constants/Pages";
import MenuSubmenuOrganicGroup from "./SubmenuOrganicGroup.vue";
import MenuSubmenuContextGroup from "./SubmenuContextGroup.vue";

export default {
    name: "MenuTopSearch",
    mixins: [Engine],
    props: {
        // Инициализирующее значение поиска
        initialValue: {
            type: String,
            required: false,
            default: '',
        },
        // Есть дерево страниц
        hasTree: {
            type: Boolean,
            required: false,
            default: false,
        },
        // Есть реклама
        hasAds: {
            type: Boolean,
            required: false,
            default: false,
        },
        // Групповой отчёт
        isGroup: {
            type: Boolean,
            required: false,
            default: false
        },
        // Отображать ссылки
        useLinks: {
            type: Boolean,
            required: false,
            default: false,
        },
        showDb: {
            type: Boolean,
            required: false,
            default: true
        },
        formAction: {
            type: String,
            required: false,
            default: 'report'
        },
        fieldName: {
            type: String,
            required: false,
            default: 'domain'
        },
        apiType: {
            type: String,
            required: false,
            default: 'domain_and_keyword'
        },
        placeholder: {
            type: String,
            required: false
        },
        useAutocomplete: {
            type: Boolean,
            required: false,
            default: true
        },
        enableSelect: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    data() {
        return {
            model: {
                search: "",
            },
            selectedSuggestionId: null,
            chooseDataBase: false,
            bases: this.$tm('lang.main.bases'),
            suggestion: [],
            suggestionIds: {},
            engine: null,
            base: null,
            // кол-во символов, с которых идет запрос на подгрузку подсказок в поиске
            searchLengthLoadData: 4,
            // задержка при вводе в поисковую строку перед отправкой запроса
            searchDelayLoadData: 500,
            currentBase: null,
            allowSuggestion: true,
            focusSearch: false,
            hoverSearch: false,
            pagePath: null,
            // текущая страница группового отчёта (?page=)
            currentGroupPage: '',
            // padding для строки поиска, чтобы не заходило за блок региона
            searchInputPaddingRight: null,
        }
    },
    created() {
        this.pagePath = this.extractPath(window.location.href);
    },
    mounted() {
        this.model.search = this.initialValue;
        if (this.isGroup) {
            const url = new URL(window.location.href); // Получаем текущий URL
            this.currentGroupPage = url.searchParams.get('page') || 'main'; // Если 'page' нет, используем 'main'
        }

        this.$emitter.on(Listeners.GLOBAL_STORE_GET_DATABASE, (database) => {
            this.currentBase = ArrayHelper.getObjectByAttrValue(this.bases, 'name', database.dbname);
            setTimeout(this.calcInputPadding, 100);
        });
    },
    computed: {
        isPageOrganic() {
            return Pages.ORGANIC.includes(this.pagePath);
        },
        isPageLinks() {
            return Pages.LINKS.includes(this.pagePath);
        },
        isPageContext() {
            return Pages.CONTEXT.includes(this.pagePath);
        },
        isPageAiAnswers() {
            return Pages.AI_ANSWERS.includes(this.pagePath);
        },
        currentBaseName() {
            return this.currentBase ? this.currentBase.name : null;
        },
        isPageOrganicGroup() {
            return Pages.ORGANIC_GROUP.includes(this.currentGroupPage);
        },
        isPageContextGroup() {
            return Pages.CONTEXT_GROUP.includes(this.currentGroupPage);
        },
        isPageYandexDirect() {
            return Pages.YANDEX_DIRECT.includes(this.pagePath);
        },
        getApiUrl() {
            return sprintf(
                '%s/suggestion/%s?query=%s&base=%s',
                this.$config.API_URL,
                this.apiType,
                encodeURIComponent(this.model.search),
                this.getCurrentDatabaseName
            );
        },
        getFormAction() {
            /**
             * Запросы, которые заканчиваются на слеш, редиректятся на uri без конечного слеша.
             * Это приводило к проблемам, когда POST запросы редиректились на этот же url, но браузер потом делал GET запрос.
             * Из-за этого как минимум не работали групповые отчёты.
             *
             * Поэтому слеша никогда не должно быть в конце
             */

            let formAction = this.formAction;

            if (this.isPageYandexDirect) {
                // yandex-direct/… → yandex-direct/report, yandex-direct-archive/… → yandex-direct-archive/report
                formAction = this.pagePath.split('/')[0] + '/report';
            }

            const parts = [];
            if (window.locale) {
                parts.push(window.locale);
            }

            if (formAction) {
                parts.push(formAction);
            }

            return (parts.length > 0 ? '/' + parts.join('/') : '')
                + (this.isPageLinks ? '#block-links' : '');
        },
        getCurrentDatabase() {
            return this.$store.getters.DATABASE;
        },
        getCurrentDatabaseName() {
            return this.getCurrentDatabase.dbname
        },
    },
    methods: {
        calcInputPadding() {
            nextTick(() => {
                this.searchInputPaddingRight = this.$refs.databaseContainer?.offsetWidth + 'px';
            });
        },
        // получаем ссылку отчёта (без домена, языка и GET-параметров)
        extractPath(url) {
            const u = new URL(url);
            const prefix = "/ru/";
            if (u.pathname.startsWith(prefix)) {
                return u.pathname.slice(prefix.length);
            }
            return null;
        },
        currentPlaceholder() {
            if (this.placeholder) {
                return this.placeholder;
            }

            return !this.isGroup
                ? this.$t('lang.main.promo.placeholder')
                : this.$t('lang.main.promo.placeholder_group');
        },
        doSearch(query) {
            this.model.search = query;
            this.selectedSuggestionId = query;

            this.doFilter();
        },
        paste(event) {
            event.preventDefault();
            let pasteText = event.clipboardData.getData('text');
            try {
                const url = new URL(event.clipboardData.getData('text'));
                pasteText = punycodeToUnicode(pasteText)
            } catch (e) {}
            this.model.search = pasteText

            this.doFilter();
        },
        submitForm() {
            let self = this;
            nextTick(() => {
                self.$refs.form.submit();
            });
        },
        doFilter() {
            if (!this.useAutocomplete) {
                return false;
            }

            if (this.model.search === "" || this.model.search.length < this.searchLengthLoadData || !this.allowSuggestion) {
                return false;
            }

            DomainApi
                .getSuggestion(this.apiType, {
                    query: encodeURIComponent(this.model.search),
                    base: this.getCurrentDatabaseName
                })
                .then(response => this.suggestion = response);
        },
        onChangeDatabase(e) {
            let database = e.value;
            database.dbname = database.name;
            database.sename = database.engine;
            this.$store.commit('SET_DATABASE', database);
            this.calcInputPadding();
        },
        getEngineIcon(engine) {
            return BaseEngineIcons[engine];
        },
        itemSelect() {
            this.allowSuggestion = false;
            this.submitForm();
        },
        beforeShow() {
            if (!this.allowSuggestion) {
                /**
                 * Необходимо т.к. событие @item-select происходит позже, чем @change.
                 * Запрещаем отображение подсказок при нажатии на подсказку.
                 */
                this.$refs.searchplace.hide();
            }
        },
        onHoverOrganic(event) {
            this.$emitter.emit(Listeners.TOP_MENU_ORGANIC_HOVER, event);
        },
        onHoverLinks(event) {
            this.$emitter.emit(Listeners.TOP_MENU_LINKS_HOVER, event);
        },
        onHoverContext(event) {
            this.$emitter.emit(Listeners.TOP_MENU_CONTEXT_HOVER, event);
        },
        onHoverOrganicGroup(event) {
            this.$emitter.emit(Listeners.TOP_MENU_ORGANIC_GROUP_HOVER, event);
        },
        onHoverContextGroup(event) {
            this.$emitter.emit(Listeners.TOP_MENU_CONTEXT_GROUP_HOVER, event);
        },
        onHoverAiAnswers(event) {
            this.$emitter.emit(Listeners.TOP_MENU_AI_ANSWERS_HOVER, event);
        },
    },
    watch: {
        'model.search'(val) {
            if (val === "") {
                this.suggestion = [];
            }
        },
    },
    components: {
        MenuSubmenuContextGroup,
        MenuSubmenuOrganicGroup,
        MenuSubmenuContext,
        MenuSubmenuOrganic,
        MenuSubmenuLinks,
        MenuSubmenuAiAnswers,
        Button,
        AdaptersDropdown,
        AdaptersAutoComplete,
        AdaptersLoader,
        IconField,
        InputIcon,
    },
}
</script>

<style scoped>
.menu_search__links_container {
    display: flex;
    gap: 8px;
    align-items: center;
}
.menu_search__links_container a {
    display: flex;
    gap: 6px;
    align-items: center;
    text-decoration: none;
    padding: 8px 12px;
    flex-shrink: 0;
    justify-content: center;
    border-radius: 10px;
    cursor: default;
    white-space: nowrap;
}
.menu_search__links_container span {
    font-size: 13px;
    color: #A4B1BE;
}
.menu_search__links_container i {
    color: #A4B1BE;
}
/* hover */
.menu_search__links_container a,
.menu_search__links_container a span,
.menu_search__links_container a i {
    transition: all .3s;
}
.menu_search__links_container a:hover {
    background-color: #556275;
}
.menu_search__links_container a:hover span,
.menu_search__links_container a:hover i {
    color: #fff;
}
/* active */
.menu_search__links_container a.active {
    background-color: #475569;
}
.menu_search__links_container a.active span,
.menu_search__links_container a.active i {
    color: #fff;
}

.menu_search__button {
    color: #A4B1BE;
    cursor: pointer;
    padding-right: 8px;
}
.menu_search__button.active {
    color: #88CC30;
}
.menu_search__form_search_container .p-input-icon {
    z-index: 1;
    font-size: 1.3rem;
    margin-top: -0.55rem;
    color: var(--gray-500);
}
.menu_search__form_search_container:deep(.p-autocomplete-input) {
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 300;
}
.menu_search__form_search_container:deep(.p-autocomplete-input::placeholder) {
    color: var(--text-color-secondary);
}
.menu_search__form_search_container:deep(.menu_search__form_search_input) {
    padding-right: v-bind(searchInputPaddingRight);
}
.menu_search__database_container:deep(.p-dropdown-trigger) {
    display: none;
}
.menu_search__database_container {
    right: 2px;
    top: 2px;
    height: calc(100% - 5px);
}
.menu_search__form_database {
    border: 1px solid var(--gray-200);
    background-color: var(--gray-200);
}
.menu_search__form_database:not(.p-disabled).p-focus,
.menu_search__form_database:hover,
.menu_search__form_database:not(.p-disabled).p-focus:hover {
    border-color: var(--gray-200);
}
.menu_search__form_database div,
.menu_search__form_database .fa {
    color: var(--text-color-secondary);
}
.menu_search__database_container img {
    max-height: 1rem;
    border-radius: 50%;
    margin-right: 4px;
}
.menu_search__database_container i::before {
    position: static;
    margin-left: 0.5rem;
}
.menu_search__form_database_focus {
    border-color: var(--primary-color);
}
.menu_search__container {
    display: flex;
    gap: 8px;
    align-items: center;
}
:deep(.menu_search__database_container) .p-inputtext {
    font-size: 13px !important;
    padding: 6px;
}
@media (min-width: 576px) {
    .menu_search__form {
        min-width: 430px;
    }
}
</style>

<style>
#keysoApp .menu_search__search_container .p-inputtext {
    font-size: 13px !important;
}
</style>
